export default __webpack_public_path__ + "static/media/todoApp.d57e33a5.png";